//
//
//
//
//
//
//
//
//
//
//

import { createNamespacedHelpers } from 'vuex'
import { CatChooseSelected } from 'counselor-mobile-ui'

const { mapGetters } = createNamespacedHelpers('chooseSelected')

export default {
  components: { CatChooseSelected },

  computed: {
    ...mapGetters([
      'dataList',
      'readOnly',
    ]),
  },

}
